const nimOrderCmd = {
  '1-1': {
    from: { type: 'cmd', text: '玩家给你下单但还未支付, 请积极与玩家联系哦~' },
    to: { type: 'text', text: '老板~ 您的订单还未支付哦!' },
  },
  '2-1': {
    from: {
      type: 'cmd',
      text: '下单成功，若超时大神未接单，<span style="color: #f54182">下单钻石将退回至您的账号余额，请留意钻石数量变化。</span>',
    },
    to: { type: 'text', text: '我发起了一笔新订单，赶快接单吧![{描述}]' },
  },
  '3-1': {
    from: { type: 'cmd', text: '服务时间快到了，请开始服务吧!' },
    to: {
      type: 'text',
      text: '我会按照服务时间开始哦，如果时间有变化请与我沟通~',
    },
  },
  '4-1': {
    from: {
      type: 'cmd',
      text: '你已经确认开始服务! 有任何问题请和玩家及时协商。',
    },
    to: { type: 'text', text: '我已经确认开始服务! 有任何问题请和我协商。' },
  },
  '5-1': {
    from: { type: 'cmd', text: '服务已完成，等待玩家给你作出评价!' },
    to: {
      type: 'text',
      text: '服务已完成，请对我的服务作出评价。 五星好评哦~ 谢谢!',
    },
  },
  '5-2': {
    from: { type: 'cmd', text: '玩家已对你作出评价!' },
    to: { type: 'text', text: '感谢您对我的评价，下次再找我玩哦~' },
  },
  '6-1': {
    from: {
      type: 'cmd',
      text: '大神已收到你的退款请求，会尽快处理。过时未处理，视为同意退款。',
    },
    to: {
      type: 'cmd',
      text: '玩家发起退款请求，请尽快处理。过时未处理，视为同意退款。',
    },
  },
  '7-1': {
    from: { type: 'cmd', text: '你已同意退款，系统将在24小时内退款给玩家。' },
    to: {
      type: 'cmd',
      text: '大神已经同意退款，系统将在24小时内处理，请注意查收。',
    },
  },
  '8-1': {
    from: { type: 'cmd', text: '您已经拒绝退款，请耐心和玩家沟通。' },
    to: { type: 'cmd', text: '大神拒绝退款，建议您和大神协商或者提交维权申请' },
  },
  '8-1-1': {
    from: {
      type: 'text',
      text: '大神拒绝订单[{订单号}]的退款申请，建议您和大神协商或者提交维权申请',
    },
    to: {
      type: 'text',
      text: '大神拒绝订单[{订单号}]的退款申请，建议您和大神协商或者提交维权申请',
    },
  },
  '9-1': {
    from: {
      type: 'cmd',
      text: '订单[{订单号}]的维权申请已提交成功，请耐心等待客服裁决',
    },
    to: {
      type: 'cmd',
      text: '玩家已向系统提交了订单[{订单号}]的维权申请，请提供您的维权资料，以便客服裁决',
    },
  },
  '9-1-1': {
    from: { type: 'text', text: '您已经提交维权申请，请耐心等待客服处理。' },
    to: { type: 'text', text: '您已经提交维权申请，请耐心等待客服处理。' },
  },
  '10-1': {
    from: {
      type: 'text',
      text: '客服裁决订单[{订单号}]你维权失败，订单关闭。',
    },
    to: { type: 'text', text: '客服裁决订单[{订单号}]你维权失败，订单关闭。' },
  },
  '10-1-1': {
    from: {
      type: 'text',
      text: '客服裁决订单[{订单号}]你维权成功，订单完成。',
    },
    to: { type: 'text', text: '客服裁决订单[{订单号}]你维权成功，订单完成。' },
  },
  '10-2': {
    from: {
      type: 'text',
      text: '客服裁决订单[{订单号}]你维权成功，订单关闭，系统24小时内会进行退款。请注意查收~',
    },
    to: {
      type: 'text',
      text: '客服裁决订单[{订单号}]你维权成功，订单关闭，系统24小时内会进行退款。请注意查收~',
    },
  },
  '10-2-1': {
    from: {
      type: 'text',
      text: '客服裁决订单[{订单号}]你维权失败，订单关闭，系统24小时内会退款给玩家。',
    },
    to: {
      type: 'text',
      text: '客服裁决订单[{订单号}]你维权失败，订单关闭，系统24小时内会退款给玩家。',
    },
  },
  '11-1': {
    from: {
      type: 'text',
      text: '由于您未发及时提交订单[{订单号}]的维权资料，订单退款失败。',
    },
    to: {
      type: 'text',
      text: '由于您未发及时提交订单[{订单号}]的维权资料，订单退款失败。',
    },
  },
  '11-1-1': {
    from: {
      type: 'text',
      text: '用户放弃订单[{订单号}]的维权申请，订单不退款，会按照正常流程结算',
    },
    to: {
      type: 'text',
      text: '用户放弃订单[{订单号}]的维权申请，订单不退款，会按照正常流程结算',
    },
  },
  '12-1': {
    from: {
      type: 'cmd',
      text: '您已取消订单[{订单号}]，<span style="color: #f54182">下单钻石将退回至您的账号余额，请留意钻石数量变化。</span>',
    },
    to: {
      type: 'cmd',
      text: '玩家已取消订单[{订单号}]，<span style="color: #f54182">下单钻石将退回至您的账号余额，请留意钻石数量变化。</span>',
    },
  },
  '12-2': {
    from: {
      type: 'cmd',
      text: '您已拒绝订单[{订单号}]，有任何疑问请主动与用户沟通。',
    },
    to: {
      type: 'cmd',
      text: '大神已拒绝订单[{订单号}]，<span style="color: #f54182">下单钻石将退回至您的账号余额，请留意钻石数量变化。</span>',
    },
  },
  '14-1': {
    from: {
      type: 'cmd',
      text: '由于你未及时接单， 订单[{订单号}]已过期。将全款退还给用户',
    },
    to: {
      type: 'cmd',
      text: '由于[{大神}]未及时接单，<span style="color: #f54182">订单[{订单号}]已过期。下单钻石将退回至您的账号余额，请留意钻石数量变化。</span>',
    },
  },
};
export default nimOrderCmd;
